import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { ConfigurationService } from 'src/app/_services';
import { DataService } from '../../../_helpers/index';
import { Router } from '@angular/router';

@Component({
  selector: 'app-batch-list-controller',
  template: `
    <ng-container *ngIf="designVersion === 'V1'">
      <batches [messageTitle]="messageTitle"></batches>
    </ng-container>
  `,
})
export class BatchListController implements OnInit, OnDestroy {

  designVersion: 'V1' | 'V2' | '' = '';
  messageTitle: string;
  private destroy$ = new Subject<void>();

  constructor(
    private dataService: DataService,
    private router: Router
  ) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation && navigation.extras.state) {
      this.messageTitle = navigation.extras.state.title;
    }
  }

  ngOnInit() {
    this.getCustomerDesignConfiguration();
  }

  getCustomerDesignConfiguration() {
    this.dataService.designVersion$
      .pipe(
        takeUntil(this.destroy$),
        tap(designVersion => {
          if (designVersion === 'V2') {
            this.navigateToLayout('Proceso por lotes')
          }
          this.designVersion = designVersion;
        })
      ).subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  navigateToLayout(tabName: string) {
    const config = {
      queryParams: { tabName: tabName }
    };

    this.router.navigate(['/new_configuration_layout'], config);
  }

}
